export default "__VITE_ASSET__BPV3sFU0__"